jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});


window.bvCallback = function(BV) {
	let isCalled = false;
  BV.rating_summary.on('container_added', function() {
    const ratingEl = document.querySelector('[data-bv-show="rating_summary"]')
    
		if (!ratingEl) return;

		if (isCalled) return;

		isCalled = true;
		const accordionEl = document.querySelector('[data-type="review"]')
		if (!accordionEl) return;

		const onClick = function() {
			// Go to accordion then open
			accordionEl.toggle();
		}

		ratingEl.removeEventListener('click', onClick)

		ratingEl.addEventListener('click', onClick)
  })
}